import React from 'react';
import { Container, Grid, Typography } from '@mui/material';
import CreateSecret from '../Components/CreateSecret';
import Faq from '../Components/Faq';

const FaqScreen = () => {
  return (
    <Container sx={{ mt: 2 }}>
  <Grid container spacing={2} direction="column">
    <Grid item xs={12}>
      <Faq />
    </Grid>
  </Grid>
</Container>
  );
};

export default FaqScreen;
